export default "793f0087f2572f20.woff2"